/**
 * @flow
 * @relayHash c609488146f4303a072c829c43acee62
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type WMLeftSectionResultSubscriptionVariables = {|
  event_id: string,
  quarter_id: string,
|};
export type WMLeftSectionResultSubscriptionResponse = {|
  +golfLeaderboardFindEventById: ?{|
    +event_id: ?number,
    +quarter_id: ?number,
  |}
|};
export type WMLeftSectionResultSubscription = {|
  variables: WMLeftSectionResultSubscriptionVariables,
  response: WMLeftSectionResultSubscriptionResponse,
|};
*/


/*
subscription WMLeftSectionResultSubscription(
  $event_id: ID!
  $quarter_id: ID!
) {
  golfLeaderboardFindEventById(event_id: $event_id, quarter_id: $quarter_id) {
    event_id
    quarter_id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "event_id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "quarter_id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "golfLeaderboardFindEventById",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "event_id",
        "variableName": "event_id"
      },
      {
        "kind": "Variable",
        "name": "quarter_id",
        "variableName": "quarter_id"
      }
    ],
    "concreteType": "updateGolfLeadarboardType",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "event_id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "quarter_id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "WMLeftSectionResultSubscription",
    "type": "Subscriptions",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "WMLeftSectionResultSubscription",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "subscription",
    "name": "WMLeftSectionResultSubscription",
    "id": null,
    "text": "subscription WMLeftSectionResultSubscription(\n  $event_id: ID!\n  $quarter_id: ID!\n) {\n  golfLeaderboardFindEventById(event_id: $event_id, quarter_id: $quarter_id) {\n    event_id\n    quarter_id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '065cf2ced35d8250832b4b42b967d2b4';
module.exports = node;
